import { render, staticRenderFns } from "./formCompetition.vue?vue&type=template&id=2bc1dd5c&scoped=true&"
import script from "./formCompetition.vue?vue&type=script&lang=js&"
export * from "./formCompetition.vue?vue&type=script&lang=js&"
import style0 from "./formCompetition.vue?vue&type=style&index=0&id=2bc1dd5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc1dd5c",
  null
  
)

export default component.exports